import { render, staticRenderFns } from "./CustomerCase.vue?vue&type=template&id=d0710ddc&scoped=true&"
import script from "./CustomerCase.vue?vue&type=script&lang=js&"
export * from "./CustomerCase.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCase.vue?vue&type=style&index=0&id=d0710ddc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0710ddc",
  null
  
)

export default component.exports